<template>
  <div>
    <!-- 适配所有的设备图标 -->
    <el-popover
    placement="top-start"
    title="设备信息"
    width="200"
    trigger="hover">
    <div>
      <div v-if="(message.state == null || message.state == '') && (message.devId == null || message.devId == '')">{{ '设备名：'+message.devName }}</div>
      <div v-if="message.devId">{{ '设备ID：'+message.devId }}</div>
      <div v-if="message.state">状态: <span :style="{color:message.color}">{{ message.txt =='在线' && !!!message.devId ?'未安装':message.txt }}</span> </div>
   </div>
    <div slot="reference">
        <div ref="dom"></div>
    </div>
    </el-popover>
  </div>
</template>

<script>
import * as d3 from 'd3'
import {getIcon} from '../drawing_list'
export default {
  inject:['getNode'],
  data() {
    return {
      borderColor: '#979797',          // 边框颜色
      backColor: 'transparent',        // 背景颜色
      openPolice: false,               // 开启报警
      openOnLine: false,               // 是否在线
      openOffLine:false,               // 是否离线
      polineColor: 'red',              // 报警颜色
      onLineColor: 'green',            // 在线颜色
      offLineColor: '#979797',         // 离线颜色
      interArr:[],
      defaultColor:'#979797',
      message:{
        devName:'',
        state:false,
        color:'#979797',
        txt:'',
        devId:''
      },
    };
  },
  mounted(){
    console.log('打开测试---------')
    const node = this.getNode();
    this.init(node);
  },
  beforeDestroy(){
    this.interArr.forEach(item=>{
      clearTimeout(item);
    })
  },
  methods:{ 
    init(node) {
      this.renderSvg(node);
      this.bindingNode(node);
    },
    renderSvg(node){
      // console.log('测试-----?????------++++++',node.getData(),'uuid',uuidv4())
      let {svgData} = node.getData();
      this.message.devName = svgData.devName;
      // 获取本地设备图标 暂时无接口 所以才获取 为了 防止项目转让时 图片不显示问题
      let icon = getIcon(svgData.devType);

      // 渲染svg
      d3.xml(icon).then(res=>{
        const result = res.getElementsByTagName('svg')[0];
        const result2 = d3.select(result).html();

        let size = '35'

        if(svgData.devType == 'gahft'){
          size = '50'
        }

        console.log('获取svg',result2)
        // '#'+this.domId
        d3.select(this.$refs.dom)
          .attr('width',"100%")
          .attr('height',"100%")
          .append('svg')
            .attr('style','margin-top:10px')
            .attr('xmlns:xlink', 'http://www.w3.org/1999/xlink')
            .attr('xmlns', 'http://www.w3.org/2000/svg')
            .attr('fill', '#979797')
            .attr('viewBox', `0 0 ${size} ${size}`)	//	这个参数不能少
            .attr('width', '33px')
            .attr('height', '33px')
            .html(result2)
      })
    },
    setColor(color,bgColor = 'transparent'){
      console.log('修改颜色')
      d3.select(this.$refs.dom).selectAll('svg')
        .selectAll('*')
        .attr('stroke',color)
        .attr('fill',bgColor);
    },
    bindingNode(node){
      node.on('change:data',(res)=>{
        setTimeout(()=>{
          let {current}  = res;
          if(current.svgData.borderColor != '')
            this.borderColor = current.svgData.borderColor;
            this.setColor(this.borderColor);
          if(current.svgData.backColor != '')
            this.backColor = current.svgData.backColor;
            this.setColor(this.defaultColor,this.backColor);
          if(current.svgData.openPolice){
            let ms = 0;
            this.borderColor = current.svgData.polineColor||this.polineColor;
            this.setColor(this.borderColor);
            let interCode = setInterval(()=>{

              if(ms % 2 != 0){
                this.borderColor = current.svgData.polineColor||this.polineColor;
                this.setColor(this.borderColor);
              }else{
                this.borderColor = this.onLineColor;
                this.setColor(this.borderColor);
              }
              ms++;
            },1000)
            this.interArr.push(interCode);
          }
          if(current.svgData.openOnLine){
            this.borderColor = current.svgData.onLineColor || this.onLineColor;
            this.setColor(this.borderColor);
          }
          if(current.svgData.openOffLine){
            this.borderColor = current.svgData.offLineColor || this.offLineColor;
            this.setColor(this.borderColor);
          }

          // 设置状态   openPolice: false, // 开启报警 openOnLine: false, // 是否在线openOffLine:false, // 是否离线
          this.message = this.message || {devName:current.svgData.devName || '未知设备'}
          this.message.devId = current.svgData.devId
          this.message.state = true;
          this.message.txt =  current.svgData.openPolice?'报警': current.svgData.openOnLine?'在线':'离线';
          this.message.color =  current.svgData.openPolice?current.svgData.polineColor|| current.svgData.polineColor:this.openOnLine?current.svgData.onLineColor || this.onLineColor:current.svgData.onLineColor || this.onLineColor;
        },500)
      })
    }
  }
}
</script>

<style>

</style>